import { useState, useRef, useEffect } from "react"
import { OptionItem, OptionsList, SelectButton } from "./Selectors.styles"
import { SelectContainer } from "./Selectors.styles"
import { fontSizes } from "../../consts"


type CustomSelectProps = {
  label?: string
  options: string[]
  value: string
  onChange: (option: string) => void
  id: string
  ariaLabel: string
  size?: 'sm' | 'md' | 'lg'
  fontSize?: number | typeof fontSizes
  color?: string
  textColor?: string
  bold?: boolean
}

export const CustomSelect: React.FC<CustomSelectProps> = ({
  label,
  options,
  value,
  onChange,
  id,
  ariaLabel,
  size = 'md',
  color,
  textColor,
  fontSize = fontSizes.small,
  bold = true
}) => {
  const [optionsOpen, setOptionsOpen] = useState<boolean>(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOptionsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <SelectContainer ref={containerRef} size={size} color={color} textColor={textColor}>
      {label && <label htmlFor={id}>{label}</label>}
      <SelectButton
        type="button"
        id={id}
        aria-label={ariaLabel}
        aria-haspopup="listbox"
        aria-expanded={optionsOpen}
        onClick={() => setOptionsOpen(!optionsOpen)}
        fontSize={fontSize}
        bold={bold}
      >
        <span className="select-value">{value}</span>
        <span
          style={{
            color: 'gold',
            display: 'inline-block',
            transform: optionsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
            marginLeft: '8px'
          }}
        >
          ▼
        </span>
      </SelectButton>
      {optionsOpen && (
        <OptionsList id={`${id}-options`} role="listbox">
          {options.map((option) => (
            <OptionItem
              key={option}
              fontSize={fontSize}
              role="option"
              isSelected={value === option}
              aria-selected={value === option}
              aria-label={option}
              onClick={() => {
                onChange(option)
                setOptionsOpen(false)
              }}
            >
              {option}
            </OptionItem>
          ))}
        </OptionsList>
      )}
    </SelectContainer>
  )
}